<template>
    <div class="file-preview">
        <div v-if="!isRecursive" class="file-preview-footer text-right">
            <button type="button" class="btn btn-danger" @click="close">{{translate('close')}}</button>
        </div>
        <div class="file-preview-content">
            <div class="container" v-if="data && mutableViewer == 'eyp'" style="padding-top: 30px;">
                <div class="float-right">
                    Ver: 
                    {{data.Version}}
                </div>
                <h4>
                    {{data.FileName}}
                    <small class="text-muted">{{data.Size | prettyBytes}}</small>
                </h4>
                <div class="row">
                    <div class="col-6">
                        <div class="card">
                            <div class="card-header">{{translate('filePreview.eypPreview.ustVeri')}}</div>
                            <div class="card-body">
                                <table class="table table-borderless table-sm ozet">
                                    <tbody>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.ustYazi')}}</td>
                                            <td>:</td>
                                            <td>
                                                <!-- <button type="button" @click="download('ustyazi')" class="btn btn-link" style="padding:0;">{{data.Ustveri.DosyaAdi}}</button> -->
                                                <file-download-link :document="data.Ustyazi" :isOnlineView="isOnlineView" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                                                
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.date')}}</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.Tarih | date }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.docId')}}</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.BelgeId}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.ozId')}}</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.OzId}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.belgeNo')}}</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.BelgeNo}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.subject')}}</td>
                                            <td>:</td>
                                            <td>{{data.Ustveri.Konu}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.securityLevel')}}</td>
                                            <td>:</td>
                                            <td>
                                                {{data.Ustveri.GuvenlikKodu | eypSecurityCode }}
                                                <div class="text-muted" v-if="data.Ustveri.GuvenlikDerecesiTarihi">({{data.Ustveri.GuvenlikDerecesiTarihi | date }})</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.olusturan')}}</td>
                                            <td>:</td>
                                            <td>
                                                <button @click="showOzne(data.Ustveri.Olusturan, translate('filePreview.eypPreview.olusturanInformation'))" class="btn btn-link" style="padding:0;">{{data.Ustveri.Olusturan.Adi}}</button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.dagitimlar')}}</td>
                                            <td>:</td>
                                            <td>
                                                <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(d.Item, translate('filePreview.eypPreview.dagitimInformation'))" v-for="d in data.Ustveri.Dagitimlar" :key="d.KKK">
                                                    {{d.Item.Adi}}
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{translate('filePreview.eypPreview.attachments')}}</td>
                                            <td>:</td>
                                            <td>
                                                <div v-for="d in data.Ustveri.Ekler" :key="d.Id">
                                                    <file-download-link :document="convertEypAttachmentToDocument(d)" :isOnlineView="isOnlineView" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                                                    <!-- <button @click="download(d.Id)" class="btn btn-link" style="padding:0; text-align:left;">
                                                        {{d.Ad}}
                                                    </button> -->
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card" v-if="data.BelgeHedef && data.BelgeHedef.length" style="margin-bottom:16px;">
                            <div class="card-header">{{translate('filePreview.eypPreview.docTarget')}}</div>
                            <div class="card-body">
                                <div v-for="h in data.BelgeHedef" :key="h.Adi">
                                    <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(h, translate('filePreview.eypPreview.docTargetInformation'))">
                                        {{h.Adi}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">{{translate('filePreview.eypPreview.docSignature')}}</div>
                            <div class="card-body">
                                <div v-for="h in data.BelgeImza" :key="h.Adi">
                                    <button class="btn btn-link" style="padding:0; text-align:left;" @click="showOzne(h.Imzalayan, translate('filePreview.eypPreview.docSignerInfo'))">
                                        {{h.Imzalayan.Adi}}
                                    </button>
                                </div>
                                <div v-if="!data.BelgeImza || data.BelgeImza.length == 0" class="text-center text-muted" style="font-style:italic;">
                                    {{translate('filePreview.eypPreview.noSignature')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <file-preview v-if="eypFileDetail" :file="eypFileDetail" :isOnlineView="isOnlineView" :viewer="eypFileViewer" :isRecursive="true" @close="closeEypModal"></file-preview>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'office'">
                <div v-if="iframeUrl" class="text-center text-muted" >
                    <VueDocPreview :url="iframeUrl" type="office" :height="92" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'text'">
                <div v-if="iframeUrl" class="text-muted" >
                    <VueDocPreview :url="iframeUrl" type="text" :height="80" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'code'">
                <div v-if="iframeUrl" class="text-muted" >
                    <VueDocPreview :url="iframeUrl" type="code" language="xml" :height="80" />
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div>
            
            <!-- old pdf viewer component -->
            <!-- <div class="container-fluid pdf-outer-container" v-else-if="mutableViewer == 'pdf'">
                <div v-if="iframeUrl" class="pdf-container">
                    <div>
                            <PDFViewer2 :pdfUrl="iframeUrl" ref="pdfViewer"/>
                    </div>
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div> -->
            
            <!-- new pdf viewer component -->
            <div class="pdf-cont" v-else-if="mutableViewer == 'pdf'">
                <div v-if="iframeUrl" class="">
                    <div>
                            <PDFViewer :pdfUrl="iframeUrl"></PDFViewer>
                    </div>
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer == 'image'">
                <div v-if="iframeUrl" class="text-muted" >
                    <iframe class="imageFrame" :src="iframeUrl"></iframe>
                </div>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    Yükleniyor...
                </div>
            </div>
            <div class="container-fluid" v-else-if="mutableViewer != 'eyp'">
                <iframe class="iframe" v-if="iframeUrl" :src="iframeUrl"></iframe>
                <div v-else class="text-center text-muted" style="padding:100px 0">
                    {{translate('loading')}}
                </div>
            </div>
            <div v-else-if="error" class="text-center text-danger" style="padding:100px 0">
                {{error.Message}}
                <div v-for="(e, i) in error.ModelState" :key="i">
                    <div v-for="(a, ai) in e" :key="ai">{{a}}</div>
                </div>
            </div>
            <div v-else class="text-center text-muted" style="padding:100px 0">
                {{translate('loading')}}
            </div>
            <!-- <code>{{file}}</code>
            <hr>
            <code>{{data}}</code> -->
        </div>

        <!-- ÖZNE PREVIEW -->
        <div v-if="ozne" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ozneTitle || "Detaylar" }}</h5>
                    <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="ozne = null">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <b>{{ translate('filePreview.oznePreview.ozneInformation:' + ozneKind) }}</b>
                            <table class="table table-borderless table-sm ozet">
                                <tbody v-if="ozne.Kind == 'KurumKurulus'">
                                    <tr>
                                        <td>{{ translate('filePreview.oznePreview.name')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                    <tr title="Kurum Kimlik Kodu">
                                        <td>{{ translate('filePreview.oznePreview.kkKodu')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.KKK}}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="ozne.Kind == 'GercekSahis'">
                                    <tr title="T.C. Kimlik No">
                                        <td>{{ translate('filePreview.oznePreview.tckn')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.TCKN}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ translate('filePreview.oznePreview.name')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                    <tr v-show="ozne.Unvan">
                                        <td>{{ translate('filePreview.oznePreview.title')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.Unvan}}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="ozne.Kind == 'TuzelSahis'">
                                    <tr title="T.C. Kimlik No">
                                        <td>{{ translate('filePreview.oznePreview.mersisNo')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.MersisNo}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ translate('filePreview.oznePreview.Id')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.Id}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ translate('filePreview.oznePreview.name')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.Adi}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <b>{{ translate('draftEyp.contactDetails')}}</b>
                            <table class="table table-borderless table-sm ozet">
                                <tbody v-if="ozne.IletisimBilgisi">
                                    <tr v-if="ozne.IletisimBilgisi.Telefon">
                                        <td>{{ translate('draftEyp.phone')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Telefon}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Telefon2">
                                        <td>{{ translate('draftEyp.phone2')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Telefon2}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.EPosta">
                                        <td>{{ translate('draftEyp.email')}}</td>
                                        <td>:</td>
                                        <td><a :href="'mailto:' + ozne.IletisimBilgisi.EPosta">{{ozne.IletisimBilgisi.EPosta}}</a></td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Faks">
                                        <td>{{ translate('draftEyp.fax')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Faks}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Web">
                                        <td>{{ translate('draftEyp.web')}}</td>
                                        <td>:</td>
                                        <td><a :href="ozne.IletisimBilgisi.Web">{{ozne.IletisimBilgisi.Web}}</a></td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Adres">
                                        <td>{{ translate('draftEyp.address')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Adres}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Ilce">
                                        <td>{{ translate('draftEyp.district')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Ilce}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Il">
                                        <td>{{ translate('draftEyp.province')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Il}}</td>
                                    </tr>
                                    <tr v-if="ozne.IletisimBilgisi.Ulke">
                                        <td>{{ translate('draftEyp.country')}}</td>
                                        <td>:</td>
                                        <td>{{ozne.IletisimBilgisi.Ulke}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" @click="ozne = null">{{ translate('close')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- ÖZNE PREVIEW SONU -->
    </div>
</template>
<script>
import axios from 'axios'
import VueDocPreview from "vue-doc-preview";
import fileDownloadLink from '../components/FileDownloadLink.vue'
// import PDFViewer2 from './PDFComponent/PDFViewer2.vue';
import PDFViewer from './PDFComponent/PDFViewer.vue'; 

export default {
    name: "FilePreview",
    components: {
      VueDocPreview,
    // PDFViewer2,
    fileDownloadLink,
    PDFViewer,
    },
    props: {
        file: {
            type: Object,
            required: true
        },
        viewer: {
            type: String,
            default: 'eyp'
        },
        isOnlineView: {
            type: Boolean,
            default: true
        },
        isRecursive: {
            type: Boolean,
            default: false
        }
    },
    data(){
        
        return {
            pageCount2: [],
            page: null,
            pageCount: 1,
            showAllPages: true,
            data: null,
            error: null,
            ozne: null,
            ozneTitle: null,
            iframeUrl: null,
            width : screen.width*0.6,
            subFileDetail:null,
            mutableFile: this.file,
            eypFileDetail: null,
            eypFileViewer: null,
            mutableViewer: this.viewer,
            pdfData: null,
        };
    },
    watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1
    },
        ozne: {
        handler(newVal) {
        // Trigger re-evaluation of the computed property when ozne changes
        console.log(newVal)
        this.ozneKind;
        },
        immediate: true
    }
    },
    created(){
        document.getElementsByTagName('body')[0].style = 'overflow:hidden';

        switch(this.mutableViewer){
            case "eyp":
                axios.post('previeweyp/post', {
                    EntityId : this.mutableFile.EntityId,
                    DocumentId: this.mutableFile.Id,
                    EntityType: this.mutableFile.EntityType ?? "Job"
                }).then(x => {
                    this.data = x.data;
                })
                .catch(x => {
                    console.log('Önizleme verisi alınamadı.', x.response);
                    this.error = x.response.data;
                })
                break;
            case "pdf":
                this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                    //this.getPdfData();
                })
                break;
            case "office":
            this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "text":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "code":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "image":
            this.getDownloadUrl()
                .then(x => {
                    var imageUrl = x.data.Data.Url;
                    console.log(x)
                    fetch(imageUrl)
                        .then((response) => response.blob())
                        .then((blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            this.iframeUrl = reader.result;
                        };
                        reader.readAsDataURL(blob);
                    });
                })
                break;
            default:
                this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = this.viewerUrl + x.data.Data.Url;
                })
                break;
        }

        
    },
    destroyed(){
        document.getElementsByTagName('body')[0].style = '';
    },
    computed: {
        viewerUrl(){
            return this.mutableViewer == 'office365' ? 'https://view.officeapps.live.com/op/view.aspx?src=' : 'https://docs.google.com/gview?embedded=true&url=';
        },
        ozneKind() {
            const kind = this.ozne ? this.ozne.Kind : null;

            if (kind === 'KurumKurulus') {
            return this.translate('filePreview.oznePreview.ozneKinds.kurumKurulus');
            } else if (kind === 'GercekSahis') {
            return this.translate('filePreview.oznePreview.ozneKinds.gercekSahis');
            } else if (kind === 'TuzelSahis') {
            return this.translate('filePreview.oznePreview.ozneKinds.tuzelSahis');
            }

            return kind;
        }
    },
    methods:{
        closeEypModal(){
            console.log("hop100");
            this.eypFileDetail = null;
        },
        getPdfData(){
            if(this.pdfData){
                return;
            }
            else {
                axios({
                    url: this.iframeUrl, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    
                    // create file link in browser's memory
                   // this.pdfData =  response.data;
                   new Response(response.data).arrayBuffer().then((d)=> {
                    this.pdfData = new Uint8Array(d);
                   });
                });
            }
        },
        handleDocumentRender() {
        this.isLoading = false
        this.pageCount = this.$refs.pdfRef.pageCount
        },
        close(){
            if(this.eypFileDetail)
                this.closeEypModal();
            else
                this.$emit('close');
        },
        showOzne(ozne, title){
            this.ozne = ozne;
            this.ozneTitle = title;
        },
        download(attachmentId){
            
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/previeweyp/createDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  AttachmentId: attachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        convertEypAttachmentToDocument(data){
            var result = {...data};
            result.AttachmentId = data.Id;
            result.FileName = data.Ad;
            return result;
        },
        downloadEypAttachment(attachment, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/previeweyp/createDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  AttachmentId: attachment.AttachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url+ (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },

        showEypAttachment(document,type){
            var oldDoc = {...this.mutableFile};
            this.eypFileDetail = document;
            this.eypFileViewer = type;
            this.eypFileDetail.DocumentId = oldDoc.Id;
            this.eypFileDetail.EntityId = oldDoc.EntityId;
            this.eypFileDetail.OldEntityType = oldDoc.EntityType;
            this.eypFileDetail.EntityType = "eyp";

        },
        getDownloadUrl(){
            var entityType = this.mutableFile.EntityType ?? "job";
            var url = "";
            var obj = { EntityId : this.mutableFile.EntityId };
            if(entityType == "job"){
                url = this.mutableFile.UnsignedFile ? `/job/createDocumentUrl/` : `/job/createAttachmentUrl/`;
                obj.IsFormatted = this.mutableFile.IsFormatted;
                if(this.mutableFile.UnsignedFile) {
                    obj.DocumentId = this.mutableFile.Id;
                    obj.IsSigned = false;
                } else {
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }else if(entityType == "IncomingDoc"){
                url = this.mutableFile.DocumentId ? `/incomingDoc/createDocumentUrl/` : `/incomingDoc/createAttachmentUrl/`;
                
                if(this.mutableFile.Id)
                  obj.DocumentId = this.mutableFile.Id;

                  if(this.mutableFile.DocumentId)
                  obj.DocumentId = this.mutableFile.DocumentId;

            }else if(entityType == "eyp"){
                url =  `/previeweyp/createDocumentUrl/`;
                obj.DocumentId = this.mutableFile.DocumentId;
                obj.AttachmentId = this.mutableFile.AttachmentId;
                obj.EntityType = this.mutableFile.OldEntityType;
            }
            else if(entityType == "Rem"){
                url = this.mutableFile.DocumentId ? `/rembox/createDocumentUrl/` : `/rembox/createAttachmentUrl/`;
                
                if(this.mutableFile.Id){
                    obj.EntityId = this.mutableFile.EntityId;
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }
            else if(entityType == "RemMessageDraft"){
                url = `/remMessageDraft/createAttachmentUrl/`;
                if(this.mutableFile.Id){
                    obj.EntityId = this.mutableFile.EntityId;
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }
            else if(entityType == 'Draft'){
                url = !this.mutableFile.IsAttachment ? `/draft/createDocumentUrl/` : `/draft/createAttachmentUrl/`;
                obj.IsFormatted = this.mutableFile.IsFormatted;
                if(!this.mutableFile.IsAttachment){
                    obj.DocumentId = this.mutableFile.Id;
                }
                if(this.mutableFile.IsAttachment){
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }
            return axios.post(url, obj);
        }
    }
}
</script>
<style scoped>
    .container-fluid{
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .file-preview {
        position:fixed;
        top:58px;
        right:0;
        bottom:0;
        left:0;
        background:#FFF;
    }

    .file-preview-content {
        position:fixed;
        top:58px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
    }

    .file-preview-footer {
        z-index: 999;
        position: fixed;
        right:0;
        left:0;
        padding: 15px;
        margin-right: 15px;
    }

    .iframe {
        position: fixed;
        left: 0;
        right: 0;
        width: 100%;
        top: 59px;
        bottom: 50px;
        height: calc(100% - 113px);
    }
    .imageFrame {
        position: fixed;
        align-self: center;
        justify-self: center;
        left: 10px;
        right: 0;
        width: 100%;
        top: 69px;
        bottom: 50px;
        height: calc(100% - 113px);
        border: 1px solid transparent;
    }
    .pdf-container{
        display: flex;
        justify-content: center;
    }
    .pdf-outer-container{
        background-color: #ccc;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .pdf-cont{
        padding: 30px;
    }
</style>